import { Form } from 'formik';
import styled from 'styled-components';

export const FormOtp = styled(Form)`
  position: relative;
  width: 100%;
`;
